import { useQuery } from '@apollo/client';
import { getPaginatedNodes, toPagination } from './utils';
import { AliasType, EntityStatus, PaginationSort } from '../gql/graphql';
import { useMemo } from 'react';
import { graphql } from '../gql';

export const GET_ENTITIES_BROKER_AGENCIES_OPTIONS_LIST = graphql(`
  query getBrokerageOptions(
    $pagination: PaginationRequest
    $filters: EntityFilterInput!
    $sort: PaginationSort
  ) {
    entities(pagination: $pagination, filters: $filters, sort: $sort) {
      edges {
        cursor
        node {
          agency
          uuid
          referenceId
          aliases(filters: { groupSources: true }) {
            edges {
              cursor
              queryCursor
              node {
                uuid
                name
                type
                sources
                primary
              }
            }
          }
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export function useGetEntitiesBrokeragesOptionsList({
  pageNumber = 0,
  pageSize = 1000,
  uuid,
  isAgency = true,
  isParent = undefined,
  enabled = true,
  sort,
}: {
  pageNumber?: number;
  pageSize?: number;
  uuid?: string;
  isAgency?: boolean;
  isParent?: boolean;
  enabled?: boolean;
  sort?: PaginationSort;
}) {
  const variables = {
    pagination: toPagination(pageNumber, pageSize),
    filters: {},
    sort,
  };
  if (isParent !== undefined) {
    variables.filters = {
      agency: isAgency,
      entityUuid: uuid,
      parents: isParent,
      status: EntityStatus.Active,
    };
  } else {
    variables.filters = {
      agency: isAgency,
      entityUuid: uuid,
      status: EntityStatus.Active,
    };
  }
  const { loading, error, data } = useQuery(
    GET_ENTITIES_BROKER_AGENCIES_OPTIONS_LIST,
    {
      variables,
      skip: !enabled,
    }
  );

  const brokerages = useMemo(() => {
    if (!data || !data.entities || !data.entities.edges) return [];

    return getPaginatedNodes(data.entities)
      .filter((e) => e.agency)
      .map((edge) => {
        const alias = getPaginatedNodes(edge.aliases).find(
          ({ type, primary }) => type === AliasType.LegalName && primary
        );
        return {
          value: edge.uuid,
          label: alias?.name ?? edge.referenceId ?? 'N/A',
        };
      });
  }, [data]);

  return {
    error,
    loading,
    data,
    brokerages,
  };
}
